module.exports = __webpack_public_path__ + "static/media/designthinking.d3cbac51.png";